module.exports = __webpack_public_path__ + "img/price-click-3.e0e11b76.jpg";